<i18n>
  {
    "de": {
      "options": {
        "AUTOMATIC": "Automatisch"
      }
    }
  }
</i18n>

<template>
  <Menu :buttonText="buttonText">
    <template #options>
      <MenuItem
        v-for="option in options"
        :id="`${id}-${option.value}`"
        :key="`${id}-option-${option.value}`"
        type="label"
        :label="option.label"
        :value="option.value"
        @click="onChange(option.value)"
      />
    </template>
  </Menu>
</template>

<script>
import Menu from '@/components/shared/menu/Menu.vue'
import MenuItem from '@/components/shared/menu/MenuItem.vue'

export default {
  components: {
    Menu,
    MenuItem,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
  },

  computed: {
    options() {
      return [
        { value: 'AUTOMATIC', label: this.$t('options.AUTOMATIC') },
        { value: 'ADMISSIBLE', label: this.$t('_admissibility.ADMISSIBLE') },
        { value: 'LIMITATIONS', label: this.$t('_admissibility.LIMITATIONS') },
        { value: 'NON_ADMISSIBLE', label: this.$t('_admissibility.NON_ADMISSIBLE') },
      ]
    },

    buttonText() {
      if (this.selected === 'AUTOMATIC') {
        return this.$t('options.AUTOMATIC')
      }
      return this.$t(`_admissibility.${this.selected}`)
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
